import { useEffect, useState } from 'react';

export function useLexicalMentionsMenuContainerMarginClassName() {
  const [menuVisible, setMenuVisible] = useState(false);

  useEffect(() => {
    function observerCallback() {
      if (document.getElementById('typeahead-menu')) {
        setMenuVisible(true);
      } else {
        setMenuVisible(false);
      }
    }
    const observer = new MutationObserver(observerCallback);
    observer.observe(document.body, { childList: true });

    return () => {
      observer.disconnect();
    };
  }, []);
  // if menu is showing, add bottom padding so the user can scroll to the bottom of the menu

  return menuVisible ? 'mb-[200px] md:mb-0' : '';
}
